var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumbs"},_vm._l((_vm.crumbs),function(item){return _c('li',{key:item.name},[_c('router-link',{attrs:{"to":{ name: item.name }}},[_vm._v(_vm._s(item.label))])],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }